import type { QuestionLabelProps } from '@/pages/onboarding/onboarding.types';
import { Box, Text } from '@careflux/primitives';

/** Question heading above a field group; referenced by the group's `aria-labelledby`. */
export const QuestionLabel = ({ id, children, hint, hintId }: QuestionLabelProps) => (
  <Box display="flex" align="baseline" gap="sm" wrap="wrap">
    <Text id={id} size="sm" weight="medium">
      {children}
    </Text>
    {hint && (
      <Text id={hintId} size="xs" color="muted">
        {hint}
      </Text>
    )}
  </Box>
);
